export const LOGGED_IN = 'auth/LOGGED_IN';
export const LOGGED_OUT = 'auth/LOGGED_OUT';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';